
<template>
  <!--新增敏感词-->
  <x-addEdit
    apiOrigin="PHP"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
export default {
  name: 'addDict',
  data () {
    return {
      formList: [
        {
          label: '敏感词',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入敏感词，一行一个，每个敏感词不能超过16个字',
          props: ['sensitive_desc', {
            rules: [
              { required: true, message: '请输入敏感词' }
            ]
          }]
        },
        {
          label: '替换为',
          inputType: 'input',
          options: [],
          placeholder: '不超过16个字',
          props: ['replace_desc', {
            rules: [{ required: true, message: '请输入替换词' }]
          }]
        }
      ],
      formKey: {
        sensitive_desc: undefined,
        replace_desc: undefined
      },
      addParam: {
        url: '/chat/sensitive',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/chat/sensitive/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/chat/sensitive/',
        resHandle: '' // this.resHandle
      }
    };
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    resHandle (res) {
      return {};
    },
    reqHandle (param) {
      let sensitiveStr = param.sensitive_desc.split(/\s/).join(',');
      param.sensitive_desc = sensitiveStr;
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
